import { render, staticRenderFns } from "./InvoiceNewMetadataDialog.vue?vue&type=template&id=4e8cac7e&scoped=true"
import script from "./InvoiceNewMetadataDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceNewMetadataDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceNewMetadataDialog.vue?vue&type=style&index=0&id=4e8cac7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cac7e",
  null
  
)

export default component.exports